import { render, staticRenderFns } from "./UserFeedback.vue?vue&type=template&id=599e8284&scoped=true"
import script from "./UserFeedback.vue?vue&type=script&lang=js"
export * from "./UserFeedback.vue?vue&type=script&lang=js"
import style0 from "./UserFeedback.vue?vue&type=style&index=0&id=599e8284&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599e8284",
  null
  
)

export default component.exports